import { customAlphabet } from 'nanoid';

// URL-safe, 충돌 가능성 낮은 12자 id (소문자+숫자)
const nano = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', 12);

/** 새 엔티티/링크/커맨드 id 생성. prefix는 디버깅 가독성용(선택). */
export function newId(prefix?: string): string {
  return prefix ? `${prefix}_${nano()}` : nano();
}
